'use client'

export const useMessagesToHostScript = () => {
  const handleClose = () => {
    window.parent?.postMessage({ messageType: 'close_widget' }, '*')
  }

  const handleIframeReady = () => {
    window.parent?.postMessage({ messageType: 'iframe_ready' }, '*')
  }

  return {
    handleClose,
    handleIframeReady,
  }
}
